import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const TopBar = styled.img`
  width: 50px;
`;

export const TitleTxt = styled.div`
  font-size: 49.2px;
  font-weight: bold;
  color: #971a35;
  padding-left: 100px;
`;

export const BodyTextContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;
